// Mock data for ItalSerrande SRL

export const companyInfo = {
  name: "ITALSERRANDE SRL",
  address: "Via Giuseppe Boffito 24 - 00135 - Roma (RM)",
  piva: "09270881007",
  cf: "09270881007",
  email: "italserrande@libero.it",
  phone: "337743730",
  office: "066240259",
  logo: "https://customer-assets.emergentagent.com/job_italserrande/artifacts/ixhh5vau_1000043806.png"
};

export const services = [
  {
    id: 1,
    title: "Serrande Avvolgibili",
    description: "Serrande di sicurezza per negozi, garage e locali commerciali. Installazione, manutenzione e riparazione.",
    image: "https://images.unsplash.com/photo-1765962726068-4354e40e4e23?auto=format&fit=crop&w=800&q=70",
    features: ["Motorizzate", "Manuali", "Blindate", "Coibentate"]
  },
  {
    id: 2,
    title: "Porte Sezionali",
    description: "Porte sezionali per garage basculanti e scorrevoli. Isolamento termico, sicurezza e design moderno.",
    image: "https://images.unsplash.com/photo-1779658835456-c699af0abae3?auto=format&fit=crop&w=800&q=70",
    features: ["Coibentate", "Motorizzate", "Telecomandate", "Personalizzabili"]
  },
  {
    id: 3,
    title: "Tapparelle",
    description: "Tapparelle avvolgibili in alluminio e PVC per protezione solare e privacy. Installazione e motorizzazione.",
    image: "https://images.unsplash.com/photo-1580368393844-28322c2ff03f?auto=format&fit=crop&w=800&q=70",
    features: ["Alluminio", "PVC", "Motorizzate", "Avvolgibili"]
  },
  {
    id: 5,
    title: "Cancelli",
    description: "Cancelli scorrevoli e basculanti per ogni esigenza residenziale e commerciale.",
    image: "https://images.pexels.com/photos/18143352/pexels-photo-18143352.jpeg?auto=compress&w=800",
    features: ["Scorrevoli", "Basculanti", "Personalizzati", "Motorizzati"]
  },
  {
    id: 6,
    title: "Automazioni",
    description: "Sistemi di automazione per serrande, cancelli e porte. Telecomandi e sistemi smart.",
    image: "https://images.pexels.com/photos/32574417/pexels-photo-32574417.jpeg?auto=compress&w=800",
    features: ["Motori elettrici", "Telecomandi", "Smart home", "Sicurezza"]
  },
  {
    id: 7,
    title: "Manutenzione",
    description: "Servizio di manutenzione programmata e riparazione urgente. Assistenza 24/7 per emergenze.",
    image: "https://images.pexels.com/photos/35290678/pexels-photo-35290678.jpeg?auto=compress&w=800",
    features: ["Assistenza 24/7", "Preventivi gratuiti", "Ricambi originali", "Garanzia"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Furgone Aziendale ItalSerrande",
    category: "Azienda",
    image: "https://customer-assets.emergentagent.com/job_italserrande/artifacts/7x0o0ts5_1000044355.jpg",
    description: "Il nostro furgone attrezzato per interventi rapidi"
  },
  {
    id: 2,
    title: "Officina ItalSerrande",
    category: "Azienda",
    image: "https://customer-assets.emergentagent.com/job_italserrande/artifacts/mo9w3yn1_1000044354.jpg",
    description: "La nostra officina con attrezzature professionali"
  },
  {
    id: 3,
    title: "Serranda commerciale - Centro Roma",
    category: "Commerciale",
    image: "https://images.unsplash.com/photo-1765962726068-4354e40e4e23?auto=format&fit=crop&w=800&q=70",
    description: "Installazione serranda motorizzata per negozio"
  },
  {
    id: 5,
    title: "Cancello automatico - Villa privata",
    category: "Residenziale",
    image: "https://images.unsplash.com/photo-1746155885811-ace3b5afd12d?auto=format&fit=crop&w=800&q=70",
    description: "Cancello scorrevole con automazione"
  },
  {
    id: 7,
    title: "Tapparelle - Edificio residenziale",
    category: "Residenziale",
    image: "https://images.unsplash.com/photo-1534691601885-2b18af007add?auto=format&fit=crop&w=800&q=70",
    description: "Sistema completo di tapparelle motorizzate"
  },
  {
    id: 8,
    title: "Serranda industriale - Capannone",
    category: "Industriale",
    image: "https://images.unsplash.com/photo-1771902863468-518a1d667d76?auto=format&fit=crop&w=800&q=70",
    description: "Serranda ad alta velocità per uso industriale"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Quanto tempo richiede l'installazione?",
    answer: "I tempi di installazione variano in base al tipo di prodotto. Per una serranda standard sono necessarie 2-4 ore, mentre per installazioni più complesse come cancelli automatici possono essere necessari 1-2 giorni lavorativi."
  },
  {
    id: 2,
    question: "Offrite garanzia sui prodotti?",
    answer: "Sì, tutti i nostri prodotti sono coperti da garanzia. Le serrande, le porte, i motori e i sistemi di automazione hanno una garanzia di 24 mesi."
  },
  {
    id: 3,
    question: "Quanto costa un preventivo?",
    answer: "Il sopralluogo e il preventivo sono completamente gratuiti e senza impegno. Un nostro tecnico verrà a valutare le vostre esigenze e vi fornirà un preventivo dettagliato."
  },
  {
    id: 4,
    question: "Fate riparazioni urgenti?",
    answer: "Sì, offriamo un servizio di assistenza urgente 24/7 per riparazioni di emergenza. Contattateci al 337743730 per interventi rapidi."
  },
  {
    id: 5,
    question: "Quali zone di Roma coprite?",
    answer: "Operiamo in tutta Roma e provincia. Il nostro ufficio si trova in Via Giuseppe Boffito 24, zona Trionfale, ma raggiungiamo tutti i quartieri della capitale."
  },
  {
    id: 6,
    question: "Posso automatizzare una serranda esistente?",
    answer: "Nella maggior parte dei casi sì. I nostri tecnici valuteranno la compatibilità della vostra serranda esistente con i sistemi di automazione moderni e vi proporranno la soluzione migliore."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Federica Efrati",
    role: "Cliente Verificata Google",
    text: "Professionalità e competenza. Sono loro cliente da più di 15 anni e hanno sempre risolto qualsiasi problema avessi alle serrande del mio negozio!",
    rating: 5,
    when: "2 mesi fa"
  },
  {
    id: 2,
    name: "fabio mex",
    role: "Local Guide · Google",
    text: "Ho avuto più volte modo di aver a che fare con loro: hanno risolto un problema alla serranda di un capannone dove altri non erano stati capaci, in pochissimo tempo e con una spesa irrisoria rispetto alla concorrenza. Successivamente mi sono rivolto a loro per un cancello automatico e si sono dimostrati dei veri professionisti con un lavoro a regola d'arte. Di sicuro su Roma sono un punto di riferimento su serrande e automatismi.",
    rating: 5,
    when: "1 mese fa"
  },
  {
    id: 3,
    name: "Flavio",
    role: "Cliente Verificato Google",
    text: "Servizio impeccabile e molto professionale. Avevo un problema alla serranda del box e sono intervenuti con rapidità, risolvendo il guasto in tempi brevi. Si vede che hanno una grande esperienza nel settore degli automatismi e delle chiusure. Prezzi onesti e massima cortesia. Consigliatissimi!",
    rating: 5,
    when: "2 mesi fa"
  }
];

// Google Business Profile - aggiorna i numeri verificando sul tuo profilo Google
export const googleBusiness = {
  rating: 5.0,
  reviewCount: 9,
  profileUrl: "https://share.google/m0e21cZZYFn7G7D84"
};
